export const getNotEligibleTooltipText = (
  eligibilityReasons: string[] | undefined,
  registrationError: string | null
): string => {
  // Priority: API reasons > registration error > default message
  if (eligibilityReasons && eligibilityReasons.length > 0) {
    return eligibilityReasons.join('<br/>');
  }

  if (registrationError) {
    return registrationError;
  }

  return 'You are not eligible to participate in this event.';
};

